import { OrderBuilderActions } from './../../../actions/order-builder.actions';
import { MinLotActions, MinLotActionTypes } from '../actions/min-lot.actions';
import { LotCapacity } from '@cemex-core/cmx-api/models/jobsite-std-lot/lot-capacity';
import { RESET_BUILDER } from '../../../actions/order-builder.actions';

export interface MinLotState {
  capacity: {
    [productId: number]: LotCapacity;
  };
  loading: boolean;
}

const initialState: MinLotState = {
  capacity: null,
  loading: false,
};

export function reducer(state = initialState, action: MinLotActions | OrderBuilderActions): MinLotState {
  switch (action.type) {
    case MinLotActionTypes.LOAD_MIN_LOT: {
      return {
        ...state,
        loading: true,
      };
    }
    case MinLotActionTypes.LOAD_MIN_LOT_SUCCESS: {
      return {
        ...state,
        capacity: {
          ...state.capacity,
          ...action.payload,
        },
        loading: false,
      };
    }
    case RESET_BUILDER:
    case MinLotActionTypes.RESET_MIN_LOT: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
